"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTeeTimeToMs = void 0;
const getTeeTimeToMs = (tee_time) => {
    const [hours, minutes] = tee_time.split(":");
    const date = new Date();
    date.setHours(parseInt(hours));
    date.setMinutes(parseInt(minutes));
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date.getTime();
};
exports.getTeeTimeToMs = getTeeTimeToMs;
